/**
 *
 * Hero Event Description Block
 *
 * Handling animations
 */

jQuery(document).ready(function () {

    // jQuery('.animation-holder-2021').each(function (i, animation) {
    //     var animationIdHolder = animation.id.split('#')[1];
    //     var currentAnimation = bodymovin.loadAnimation({
    //         container: document.getElementById(animation.id),
    //         renderer: 'svg',
    //         loop: true,
    //         autoplay: true,
    //         path: window.ITBL.assets + '/animations/Activate21_LP_' + animationIdHolder + '.json'
    //     })
    // })

    jQuery('.all-animation-holder-2021').each(function (i, animation) {
        var animationIdHolder = animation.id;
        var currentAnimation = bodymovin.loadAnimation({
            container: document.getElementById(animation.id),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: animationIdHolder,
        })
    })

        setTimeout(function() { 
            var heightLeftImg = jQuery("#resize-img-Left").height();
            var heightRightImg = jQuery("#resize-img-Right").height();
            var heightRightImgClassic = jQuery("#resize-img-Right-classic").height();
            jQuery(".grid-container-hold-Left").css("height", heightLeftImg);
            if (heightRightImg == 0) {
                jQuery(".grid-container-hold-Right").css("height", heightRightImgClassic);
            } else {
                jQuery(".grid-container-hold-Right").css("height", heightRightImg);
            }
         }, 500);

    
    setTimeout(function() {
        updateContentBlock2021Heights();
    }, 1500);
        
    
    var waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
          if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
          }
          if (timers[uniqueId]) {
            clearTimeout (timers[uniqueId]);
          }
          timers[uniqueId] = setTimeout(callback, ms);
        };
    })();

    function updateContentBlock2021Heights() {

        var imgContainerLeft = document.getElementById('resize-img-Left');
        var imgContainerRight = document.getElementById('resize-img-Right');
        var heightLeftImg = imgContainerLeft ? imgContainerLeft.clientHeight : 0;
        var heightRightImg = imgContainerRight ? imgContainerRight.clientHeight : 0;
        var heightRightImgClassic = jQuery("#resize-img-Right-classic").height();

        jQuery(".grid-container-hold-Left").css("height", heightLeftImg);
        if (heightRightImg == 0) {
            jQuery(".grid-container-hold-Right").css("height", heightRightImgClassic);
        } else {
            jQuery(".grid-container-hold-Right").css("height", heightRightImg);
        }
    }

    jQuery(window).resize(function () {
        waitForFinalEvent(function(){
            var containerWidth = jQuery(window).width();
            if (containerWidth >= 991) {
                updateContentBlock2021Heights();
            }
        }, 500, "some unique string");
    });

});